<template>
  <section class="app-main">
    <div class="container is-fluid is-marginless app-content">
      <!--<levelbar></levelbar>-->
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear
      >
        <router-view class="animated"></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
import Levelbar from './Levelbar'

export default {
    components: {
        Levelbar
    }
}
</script>

<style lang="scss">
@import '../../../node_modules/bulma/sass/utilities/variables';
@import '../../../node_modules/bulma/sass/utilities/mixins';

.app-main {
  padding-top: 50px;
  margin-left: 180px;
  @include mobile() {
    margin-left: 0;
  }
}
.is-fluid {
  width: 100% !important;
}
.app-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// AppMain.vue?7017c9ac